import { AxiosError } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  mapApiOptions,
  mapApiStatesToOptions,
  mapApiCountryOptions,
} from "shared/utils/mapOptions";
import * as carrierAPI from "api/carrierAPI";
import { CarrierPerformanceSummaryDto } from "models/dto/CarrierPerformanceSummaryDto";
import { CarrierDto } from "models/dto/CarrierDto";

export const fetchCarrier = createAsyncThunk<CarrierDto, string>(
  "carrier/fetchCarrier",
  async (carrierId: string, _thunkAPI) => {
    try {
      const { data } = await carrierAPI.fetchCarrierById(carrierId);
      return { ...data };
    } catch (err) {
      return _thunkAPI.rejectWithValue((err as AxiosError).response?.status);
    }
  }
);

export const starCarrier = createAsyncThunk<string, string>(
  "carrier/starCarrier",
  async (carrierId) => {
    const response = await carrierAPI.starCarrier(carrierId);
    return response.data;
  }
);

export const fetchCarrierSummary = createAsyncThunk<
  CarrierPerformanceSummaryDto,
  string
>("carrier/fetchCarrierSummary", async (carrierId) => {
  const response = await carrierAPI.fetchCarrierSummary(carrierId);
  return response.data;
});

export const saveCarrier = createAsyncThunk<void, CarrierDto>(
  "carrier/saveCarrier",
  async (carrier, thunkAPI) => {
    await carrierAPI.saveCarrier(carrier);
    thunkAPI.dispatch(fetchCarrier(carrier.id.toString()));
  }
);

export const fetchCarrierOptions = createAsyncThunk(
  "carrier/fetchCarrierOptions",
  async () => {
    const { data } = await carrierAPI.fetchCarrierOptions();
    return {
      ...data,
      addressTypes: mapApiOptions(data.addressTypes),
      phoneTypes: mapApiOptions(data.phoneTypes),
      emailTypes: mapApiOptions(data.emailTypes),
      contactRoles: mapApiOptions(data.contactRoles),
      carrierStatuses: mapApiOptions(data.carrierStatuses),
      countryRegion: mapApiCountryOptions(data.countryRegion),
      countryStates: mapApiStatesToOptions(data.countryStates),
    };
  }
);
